export default {"src":"/_next/static/media/@linkedin.28be8b3c.svg","height":30,"width":30};